<template>
  <div id="app">
    <div class="container">
      <app-navigation :options="pages" @navigate="navigate($event)"></app-navigation>
      <component :is="page" :pageconfig="pageConfig"></component>
      <br><br>
    </div>
  </div>

</template>

<script>
  import Dices from './components/app-dices.vue';
  import Teetotums from './components/app-teetotums.vue';
  import Positions from './components/app-positions.vue';
  import Matching from './components/app-matching';
  import Navigation from './components/app-navigation.vue';
  import axios from 'axios';

  export default {
    name: 'app',
    components: {
      appDices: Dices,
      appTeetotums: Teetotums,
      appPositions: Positions,
      appMatching: Matching,
      appNavigation: Navigation
    },
    data() {
      return {
        page: "",
        pages: {},
        pageConfig: {}
      }
    },
    methods: {
       navigate(page) {
         axios.get(page.url)
           .then(function (response) {
             this.pageConfig = response.data;
             this.page = page.page;
           }.bind(this));
      }
    },
    created: function () {
       axios.get('/assets/jsons/pages.json')
         .then(function (response) {
           this.pages = response.data;
         }.bind(this));
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue